/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/



import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import Background from '../../src/assets/img/brand/background.jpg';
import Resume from '../../src/assets/download/ylin-resume.pdf'
// index page sections

import amazonpng from '../../src/assets/img/brand/amazon.png';
//sample display section

import MarketAppSample from '../views/IndexSections/MarketAppSample'
import ReactWebSample from '../views/IndexSections/ReactWebSample'
import MyUsLifeAppSample from '../views/IndexSections/MyUsLifeAppSample'

import emailjs from 'emailjs-com';
class Index extends React.Component {
  state = {name: '', email:'', message: ''};
  handleName = this.handleName.bind(this);
  handleEmail = this.handleEmail.bind(this);
  handleMessage = this.handleMessage.bind(this);
  handleSubmit = this.handleSubmit.bind(this);
  redirect2 = this.redirect2.bind(this);

  handleName(event) {
    this.setState({name: event.target.value});
  }
  handleEmail(event) {
    this.setState({email: event.target.value});
  }
  handleMessage(event) {
    this.setState({message: event.target.value});
  }

  redirect2(test){
    
    window.location.href = test;
   
  }
  handleSubmit(event) {

    if (this.state.name ==='' || this.state.message === ''||this.state.email === ''){
      //event.preventDefault();
    }    
    else{
    emailjs.send("gmail",
    "template_TuXirxNW", 
    {
    "reply_to":"linyoujie@hotmail.com",
    "to_name":"来Ylin.me的消息",
    "from_name":this.state.name,
    "message_html":this.state.message,
    "from_email": this.state.email
    }, 
    "user_vvQr5arnkwBzh3s89gDbM")

    //alert('A name was submitted: ' + this.state.value);
        
  

    this.setState({name: '', email:'', message: '',messageFocused: false,emailFocused:false,nameFocused:false});
    
     //this.props.exact


  }
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }


  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative ">
            {/* shape Hero */}
            <section className=" section section-lg  pb-250" alt="Image" style ={{backgroundImage: `url(${Background})`}}>
              {/*<div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>*/}

              <div ></div>
              
              <Container className="py-lg-md d-flex">
               
                <div className="col px-0">
                  <Row>
                    
                    <Col lg="6">
                      <h1 className="display-3 text-white text-uppercase">
                        Let's build something amazing together{" "}
                        <span> </span>
                      </h1>
                      <p className="lead text-white">
                        Most materials don't last, but the codes do.
                        Let's creating things that are meaningful and lasting.
                    
                      </p>
                   
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
            
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                  
                      <Card className="card-lift--hover shadow border-0">
                      <img
                      alt="..."
                      className="img-fluid rounded shadow-lg"
                   
                      src={require("assets/img/brand/ylin.jpg")}
                      
                    />
                             <light ></light >
                        <CardBody >
                     
                       
                          <h1 className="text-primary lg text-uppercase ">
                            Tom Y. Lin
                          </h1>
                          <small className="h6 text-muted">Full-Stack Engineer</small>
                          <p className="description">
                          Motivated and easy-going person 
                          who welcomes challenging projects and 
                          enjoys working with all kinds of personalities.

                          </p>
                          <div>
                            <Badge color="primary" pill className="mr-1">
                              JAVA
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              Python
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              JavaScript
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              C++
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              PHP
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              SQL
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              Agile Development
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              App Design
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              Web Design
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              more..
                            </Badge>


                          </div>
                          <Button
                          block
                        className="btn-icon mb-3 mb-sm-0 mt-4"
                        color="github"
                        href={Resume}
                        size="lg"
                        target="_blank"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="ni ni-cloud-download-95" />
                        </span>
                        <span className="btn-inner--text">
                
                          <span className="text-warning mr-1">Download</span>
                          resume
                        </span>
                      </Button>
                        </CardBody>
                      </Card>
                    </Col>
{                    //style ={{backgroundPosition: "bottom", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundImage: `url(${envelope})`}}
}                    <Col lg="6" style={{alignSelf:"flex-end"}}>
                  

                      <Card className="card-lift--hover shadow border-0 align-items-center ">
                        <CardBody className="py-5 " >
                          
                          <div className="icon icon-shape icon-shape-warning rounded-circle ">
                            <i className="fa fa-envelope" />

                          </div>
                          <div class="css-typing   mt-4">
                          <h2 class="text-uppercase"  >
                            Hello world,
                          </h2>
                          <p >
     
                          </p >
                          <p >
                          My name is Tom. I have passion for coding 

                          </p >
                          <p>
                          like thousand of others very talented people. 
                          </p>
                          <p>
                          To show the value I'd bring to the world, 
                    
                          </p>
                          <p>
                          there are some projects I had done before.

                 
                          </p>
                          <p>
                           Please scroll down to check them out and
                          </p>
                          <p>
                            press "REPLY" button to contact me.
                          </p>
                          <div id="border"></div></div>

                          <div className="btn-wrapper mt-4 align-item-right">
                          <Button
                        className="btn-white btn-icon mb-3 mb-lg-0 "
                        color="default"
                        href="#contact-me"
                   
                        size="lg"
                      >

                        <span className="btn-inner--text ">reply</span>
                 
                 
                      </Button>{"   "}
                     

                      </div>
                      
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section bg-secondary ">
            <Container>
              <Row className="row-grid align-items-center ">
                <Col md="6" >
                  <Card className="bg-default shadow border-0 ">
                    <CardImg
                      alt="..."
                      src={require("assets/img/brand/product-nycdashboard.jpg")}
                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Software Design
                      </h4>
                      <p className="lead text-italic text-white">

                      </p>
                    </blockquote>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div>
                    <h3>Mobile App Dev</h3>
                    <p className="lead">
                      NYC Dashboard is cross-platform app for android and app.
                        It can easily turn your unused phone or tablet into a dashboard,
                        SET!!! GO!!! This is all you need for morning dash in NYC.
                    
                    </p>
                    <p>
                      There are so many disposed device everyday,
                       this app will turn your old device into useful 
                       tools and services your different way daily.
                      
                    </p>
                    <p>
                        Technology behind scene:
                        React-Native, Repo and more.
                    </p>
                    <a
                      className="font-weight-bold text-warning mt-5"
                      href="https://play.google.com/store/apps/details?id=com.esfe.NYCDashboard"
                
                    >
                      Check it out on Google Playstore.
                    </a>
                  </div>
                </Col>
                
              </Row>
            
              <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
            </Container>
          </section>
          {/* MartketApp Sample */}
          <MarketAppSample></MarketAppSample>
          
          <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">

          
              <Col md="6" className="order-md-2">
                  <Card className="bg-default shadow border-0 ">
                    <CardImg
                      alt="..."
                      src={require("assets/img/theme/landing.jpg")}
                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                       Front-End Development
                      </h4>
                      <p className="lead text-italic text-white">

                      </p>
                    </blockquote>
                  </Card>
                </Col>

                <Col md="6" className="order-md-1">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div>
                    <h3>Website Design</h3>
                    <p>
                      Worked closely with the client, and knew what they need.
                      Providing all the possible technique, and bring it to the customer.
                      With WordPress, the customer is able to update posts frequently.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Html and PHP
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-chat-round" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">MySQL/MariaDB</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Theme Customizable
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>

                
             

              </Row>
            </Container>
          </section>
   
          <MyUsLifeAppSample />
        
          <ReactWebSample> </ReactWebSample>


          <section className="section section-lg bg-gradient-default">
            <a id = "contact-me"> </a>
            <Container className=" pb-300" >
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Contact Me</h2>
                  <p className="lead text-white">
                  Sharing is an excellent way to improving 
                  and increasing quality of everything. 
                  Anything shareable is important to me,
                  Because SHARING is CARING.
                  </p>
                </Col>
              </Row>
              
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section section-lg pt-lg-0 section-contact-us">
            <Container>
              <Row className="justify-content-center mt--300">
                <Col lg="8">
                  <Card className="bg-gradient-secondary shadow">
                    <CardBody className="p-lg-5">
                      <h4 className="mb-1">Want to work with me?</h4>
                      <p className="mt-0">
                        Any Opportunity is very important to me.
                      </p>
                      <FormGroup
                        className={classnames("mt-5", {
                          focused: this.state.nameFocused
                        })}
                      >
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-user-run" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Your name"
                            type="text"
                            onFocus={e => this.setState({ nameFocused: true })}
                            onBlur={e => this.setState({ nameFocused: false })}
                            onChange={this.handleName}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup
                        className={classnames({
                          focused: this.state.emailFocused
                        })}
                      >
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-email-83" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Email address"
                            type="email"
                            onFocus={e => this.setState({ emailFocused: true})}
                            onBlur={e => this.setState({ emailFocused: false })}
                            onChange={this.handleEmail}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className= {classnames({
                          focused: this.state.messageFocused
                        })} >
                        <Input
                          className="form-control-alternative"
                          cols="80"
                          name="name"
                          placeholder= {this.state.message === '' ? "Type a message...": this.state.message}
                          rows="4"
                          type="textarea"
                          onFocus={e => this.setState({ messageFocused: true})}
                          onBlur={e => this.setState({ messageFocused: false })}
                          onChange={this.handleMessage}
                        />
                      </FormGroup>
                      <div>
                        <Button
                          block
                          className="btn-round"
                          color="default"
                          size="lg"
                          type="button"
                          
                          onClick = {()=>{ 
                            this.handleSubmit()

                            setTimeout(function() {
                              return window.location.href = '/thankyou-page';
                            }, 2000);
                            //console.log(this.state)
                            //console.log('1')
                            
                          }}
                        >
                          Send Message
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg">
          <Container>
            <Row className="row-grid justify-content-center">
              <Col className="text-center" lg="8">
                <h2 className="display-3">
                  Do you love my website? {" "}
                  <span className="text-warning">
                    Building with React.js
                  </span>
                  
                </h2>
                

                <div className="text-center">
                  <h4 className="display-4 mb-5 mt-5">
                  Technologies Behind the Scene:
                  </h4>
                  <Row className="justify-content-center">
     
                    
                  <Col lg="2" xs="3">
                      <a
                        href="https://reactjs.org/"
                        id="tooltip308866162"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866162">
                        React - A JavaScript library for building user
                        interfaces
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="3">
                      <a
                        href="https://getbootstrap.com/"
                        id="tooltip255035741"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip255035741">
                        Bootstrap 4 - Most popular front-end component library
                      </UncontrolledTooltip>
                    </Col>
   

                    <Col lg="2" xs="3">
                      <a
                        href="https://aws.amazon.com/"
                        id="tooltip308866163"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                        
                    
                          justify = "center"
                          src={amazonpng}
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866163">
                        AWS - Amazon Web Services offers reliable, scalable,
                        and inexpensive cloud computing services.
                      </UncontrolledTooltip>
                    </Col>

                    <Col lg="2" xs="3">
                      <a
                        href="https://www.adobe.com/products/photoshop.html"
                        id="tooltip646643508"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip646643508">
                        Adobe Photoshop - Software for digital images
                        manipulation
                      </UncontrolledTooltip>
                    </Col>

                  </Row>
                </div>
              </Col>
              
            </Row>

          </Container>
          
        </section>  
        </main>
        
        <CardsFooter />
      </>
    );
  }
}

export default Index;
